// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"63dc1ade","453":"54292a4b","530":"b7684f25","590":"c0065544"}[chunkId] + ".chunk.js";
};